
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.833 1.667a3 3 0 013 3v2.838a2 2 0 01-.586 1.414l-7.402 7.403c-.22.22-.345.52-.345.833 0 .65-.527 1.178-1.178 1.178H5.5a3 3 0 01-3-3V4.667a3 3 0 013-3h7.333zM5.755 9.114a.652.652 0 000 1.303h4.072a.652.652 0 000-1.303H5.755zm0-2.603a.651.651 0 100 1.301h6.706a.65.65 0 000-1.301H5.755zm0-2.605a.652.652 0 000 1.302h6.706a.65.65 0 100-1.302H5.755zM14.103 11.092c.761-.761 2-.761 2.761 0 .761.761.762 2 .001 2.762l-3.567 3.56a.652.652 0 01-.287.167l-2.627.727a.652.652 0 01-.797-.816l.778-2.562a.653.653 0 01.163-.272l3.575-3.566zm-3.27 5.99l1.667-.415-.833-.834-.417-.416-.416 1.666zm5.111-5.07a.652.652 0 00-.92 0l-.127.127.921.92.126-.125a.652.652 0 000-.921z","fill":"#fff"}})])
          )
        }
      }
    